import React, { useCallback, useEffect } from "react";
import { View, BackHandler } from "react-native";
import { useFocusEffect } from "@react-navigation/native";

import Text from "@components/AppText";
import Button from "@components/Button";
import NotFoundSvg from "@assets/svg/404svg";
import { normalize, width, height } from "@constants/metrics";
import analytics from "@services/analytics";

import t from "@constants/localization";

const PATH = "screens/PageNotFound";

const PageNotFound = ({ navigation, route = {} }) => {
  const params = route.params || {};

  const onBack = useCallback(() => {
    if (params.previousScreen === "ShopPerformance") {
      navigation.navigate("ShopPerformance");
    } else {
      navigation.navigate("Home");
    }
    return true;
  }, []);

  useEffect(() => {
    analytics.trackEvent("Not found screen", params);
  }, []);

  useFocusEffect(
    useCallback(() => {
      const backHandlerSub = BackHandler.addEventListener("hardwareBackPress", onBack);
      return () => backHandlerSub.remove();
    }, []),
  );
  return (
    <View style={{ flex: 1, backgroundColor: "white", position: "relative" }}>
      <View
        style={{
          alignSelf: "center",
          marginTop: height * 0.4,
          alignItems: "center",
        }}
      >
        <NotFoundSvg />
        <View style={{ alignItems: "center", marginTop: normalize(10) }}>
          <Text
            bold
            style={{ fontSize: normalize(16), marginBottom: normalize(5) }}
          >
            {t(`${PATH}/apology`)}
          </Text>
          <Text style={{ fontSize: normalize(16) }}>
            {" "}
            {t(`${PATH}/productNotAvailable`)}
          </Text>
        </View>
      </View>
      <View
        style={{
          marginTop: "auto",
          marginBottom: normalize(20),
          alignItems: "center",
        }}
      >
        <Button
          btnText={
            params.previousScreen === "ShopPerformance"
              ? t(`${PATH}/goToShopPerf`)
              : t(`${PATH}/goToHome`)
          }
          buttonWidth={width * 0.85}
          onPress={() => onBack()}
        />
      </View>
    </View>
  );
};

export default PageNotFound;
